import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideRouter, withEnabledBlockingInitialNavigation } from '@angular/router';
import { KeycloakService } from '../../usermgmt/src/lib/services/keycloak.service';

import { EnvServiceProvider } from '../../usermgmt/src/public-api';
import { ApiResponseInterceptor, AuthInterceptorService, InitService } from 'usermgmt';
import { VlHttpService } from '../../usermgmt/src/lib/shared/vl-http/vl-http.service';
import { DatePipe } from '@angular/common';
import { routes } from './app/app.routes';
import { ErrorInterceptor } from './app/shared/services/error.service';


const keycloakService = new KeycloakService();



keycloakService.init().then(() => {
  bootstrapApplication(AppComponent, {
    providers: [
      ...(appConfig.providers || []),
      provideRouter(routes,withEnabledBlockingInitialNavigation()),
      EnvServiceProvider,
      VlHttpService,
      InitService,
      DatePipe,
      { provide: KeycloakService, useValue: keycloakService },
      { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: ApiResponseInterceptor,
        multi: true
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: ErrorInterceptor,
        multi: true
      },
      provideHttpClient(withInterceptorsFromDi()),
    ]
  }).catch(err => console.error(err));
});



